import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { IHubCustomField } from '../../../../../../../api/hub-registration-configuration.dao';
import { EDIT_TEXT } from '../../../../../../../constants/common-labels.constants';
import { htmlToPlainText } from '../../../../../../../infrastructure/utils/common.utils';
import { HubRegistrationSettingsVM } from './hub-registration-settings.viewmodel';
import './hub-custom-field-row.scss';

type HubCustomFieldRowProps = {
    field: IHubCustomField;
    vm: HubRegistrationSettingsVM;
    isEditing?: boolean;
};

export const HubCustomFieldRow: React.FC<HubCustomFieldRowProps> = observer(({ field, vm, isEditing }) => {
    const hasRichTextLabel = vm.isRichTextLabelType(field.type);
    const displayLabel = hasRichTextLabel ? htmlToPlainText(field.label) : field.label;

    return (
        <div
            className={classnames('hub-custom-field-row', {
                'hub-custom-field-row--active': isEditing,
            })}
        >
            <span className='hub-custom-field-row__label'>{displayLabel}</span>
            <div className='hub-custom-field-row__actions'>
                <DefaultButton
                    modifier='slim'
                    className='hub-custom-field-row__edit-button'
                    text={<FormattedMessage {...EDIT_TEXT} />}
                    onClick={() => vm.openCustomFieldEditor(field)}
                />
            </div>
        </div>
    );
});
